import { menuItemGroupCardFactory } from './chunk-EEE54PHW.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuItemGroupsTableFactory.ts
var menuItemGroupsTableFactoryCore = (itemGroups, items, combos) => menuItemGroupCardFactory(itemGroups).map((itemGroup) => {
  const menuItemGroup = itemGroups[itemGroup.id];
  return __spreadProps(__spreadValues({}, itemGroup), {
    combos: menuItemGroup.parentComboIds.map((comboId) => combos[comboId].name).join(", ") || void 0,
    items: Object.keys(menuItemGroup.items).map((itemId) => items[Number(itemId)].name).join(", ") || void 0
  });
});

export { menuItemGroupsTableFactoryCore };
